import React from "react"
import lucapayLogoImage from "../../images/luca-pay/lucapay-logo.svg"
import { Link } from "gatsby"
import Logo from "../../images/logo.svg"
import classNames from "classnames"
import RightVectorImage from "../../images/new-landing/right-vector.svg"
import footerLeftVectorImg from "../../images/new-pricing/top-left-vector.png"
import footerRightVectorImg from "../../images/new-pricing/top-right-vector.png"
import tabBottomCurveImg from "../../images/new-pricing/tab-bottom-curve.svg"
import ReactGA from "react-ga"
import logo1 from "../../images/new-pricing/xero.svg"
import logo2 from "../../images/new-pricing/myob.svg"
import logo3 from "../../images/video/logo3.svg"

export default function Header({ toggleTab, activeTab, setToggle, toggle, page, queryParam }) {
  const toggleCls = classNames("navbar-toggler",
    { "collapsed": !toggle },
  )
  const mobileMenuWrapperCls = classNames(
    { "show": toggle },
  )

  const handleToggleMenu = (e) => {
    setToggle(!toggle)
  }

  const navItemClick = (navItem) => {
    ReactGA.event({
      category: `${page}_Nav Bar_${navItem}`,
      action: `${page}_Nav Bar_${navItem}`,
    })
  }

  const onLogoClick = () => {
    ReactGA.event({
      category: `Solo Plan Pricing Page_logoheader`,
      action: `Solo Plan Pricing Page_logoheader`,
    })
  }

  return (
    <div className="top">
      <div className="container">
        <div className="flex items-center justify-between">
          <a href="/" onClick={onLogoClick} className="logo flex items-center sm:justify-start justify-content-center">
            <img src={Logo} alt="logo" className="lucaplus-img pr-3 w-1/2" />
            <div className="text-brand whitespace-no-wrap ml-3 text-14">
              Simpler and Faster Business
            </div>
          </a>
          <div className="flex sm:flex hidden items-center">
            <a
              onClick={() => navItemClick("Book A Demo")}
              className="book-demo-btn focus:outline-none flex justify-center items-center mr-2"
              href="https://meetings.hubspot.com/ray-wang/meeting-with-luca-plus"
            >
              Book a Demo
            </a>
            <div>
              <img src={footerLeftVectorImg} className='sm:w-7/12 w-4/6 ml-auto' />
            </div>
            <Link
              className="signup-btn focus:outline-none flex justify-center items-center cursor-pointer"
              onClick={() => navItemClick("Sign Up")}
              to={`/sign-up/?plan=solo${queryParam && '&' + queryParam}`}
              state={{ isTrial: true, plan: "solo", price: 0 }}
            >
              Sign Up
            </Link>
            <div>
              <img src={footerRightVectorImg} className='sm:w-7/12 w-4/6 mr-auto' />
            </div>
          </div>
        </div>
        <div className="top__header">
          {/*<span className='sm:block hidden'>89% of Australian small to medium-sized businesses still process risky invoices as documents or spreadsheets</span>*/}
          {activeTab === 1 ? "Why waste time processing invoices to documents or spreadsheets?" : "Most businesses spend 2 hours or more weekly, matching invoices"}
        </div>
        <div className="subtext">
          <span className="sm:block hidden">
            Our sole trader Amy, who used to do all her invoices manually, has been able to manage her cash flow better, focus on
            growing her business and is saving time dealing with painful bookkeeping.<br /><br />
            So if you’re happy using a simple cloud-based tool to get paid 32% faster, then you’re in the right place!<br /><br />
            Talk about efficiency!

          </span>
          <span className="block sm:hidden">
            Sole trader Amy, has been able to manage her cash flow better, focus on growing her business, and is saving
            time dealing with painful bookkeeping.
          </span>
        </div>
        <div className="flex sm:hidden flex-col items-center justify-content-center">
          <a
            onClick={() => navItemClick("Book A Demo")}
            className="book-demo-btn focus:outline-none flex justify-center items-center"
            href="https://meetings.hubspot.com/ray-wang/meeting-with-luca-plus"
          >
            Book a Demo
          </a>
          <div className="flex items-center">
            <div>
              <img src={footerLeftVectorImg} className="mt-4" />
            </div>
            <Link
              className="signup-btn focus:outline-none flex justify-center items-center cursor-pointer mx-2"
              onClick={() => navItemClick("Sign Up")}
              to={`/sign-up/?plan=solo${queryParam && '&' + queryParam}`}
              state={{ isTrial: true, plan: "solo", price: 0 }}
            >
              Sign Up
            </Link>
            <div>
              <img src={footerRightVectorImg} className="mt-4" />
            </div>
          </div>
        </div>
        {/*<div className="flex text-18 justify-content-center sm:flex-row flex-col sm:mt-0 mt-20">*/}
        {/*  <div*/}
        {/*    className={`${activeTab === 1 ? "text-secondary" : "text-neutral-7"} flex flex-col items-center cursor-pointer sm:mr-24 sm:mb-0 mb-3`}*/}
        {/*    onClick={() => toggleTab(1)}>*/}
        {/*    I don’t use any accounting software*/}
        {/*    {activeTab === 1 && <img src={tabBottomCurveImg} className='-mt-3' />}*/}
        {/*  </div>*/}
        {/*  <div*/}
        {/*    className={`${activeTab === 2 ? "text-secondary" : "text-neutral-7"} flex flex-col items-center cursor-pointer`}*/}
        {/*    onClick={() => toggleTab(2)}>*/}
        {/*    I’m using accounting software*/}
        {/*    {activeTab === 2 && <img src={tabBottomCurveImg} className="w-5/6 -mt-3" />}*/}
        {/*  </div>*/}
        {/*</div>*/}
        {activeTab === 2 &&
        <section className="video-landing__partners flex sm:flex-row flex-col border-0 items-center">
          <div className="container lg:px-8 sm:flex sm:items-center sm:justify-between inner">
            <div className="left mr-0 sm:mr-8">
              <h2 className="accredited">Accounting Software Supported</h2>
            </div>
            <div className="right ">
              <div className="logos flex sm:flex-row flex-col">
                <div>
                  <img src={logo1} className="logo" />
                </div>
                <div>
                  <img src={logo2} className="logo ml-4 lg:ml-8 sm:my-0 my-5" />
                </div>
                <div>
                  <img src={logo3} className="logo ml-4 lg:ml-8" />
                </div>
              </div>
            </div>
          </div>
        </section>}
      </div>
    </div>
  )
}
